import type { FC, PropsWithChildren } from 'react';

import { useReduxAnnouncerBridge } from './hooks';

const ReduxAnnouncerBridge: FC<PropsWithChildren> = () => {
  useReduxAnnouncerBridge();

  return null;
};

export default ReduxAnnouncerBridge;
